import { SxProps, Theme } from '@mui/material';
import Box from '@mui/material/Box';

import { OverflowAwareText } from '~components/Order/ordersDispatchStyledComponents';
import { Load } from '~hooks/useLoad/models';
import { GeofenceStartAdornment } from '~pages/Settings/Administration/Sites/components/GeofenceStartAdornment';
import { extractWaypointData } from '~utils/orders';

interface PickupAndDropoffColumnProps {
  load: Load;
  sx?: SxProps<Theme>;
}

export default function PickupAndDropoffColumn({
  load,
  sx,
}: PickupAndDropoffColumnProps) {
  const pickUp = extractWaypointData(load.pickUpWaypoints[0]);
  const dropOff = extractWaypointData(load.dropOffWaypoints[0]);

  return (
    <Box sx={sx}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
        {[pickUp, dropOff].map((site, index) => (
          <Box
            key={index}
            sx={{
              display: 'flex',
            }}
          >
            <GeofenceStartAdornment
              geofenceType={site?.geofenceType}
              isLoading={false}
              sx={{ pr: 0.5 }}
            />

            <OverflowAwareText>{site?.name || '-'}</OverflowAwareText>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
